<template>
    <div class="flex-none">
        <label :class="[classes ? classes : 'items-start', disabled ? 'cursor-not-allowed' : 'cursor-pointer']" class="flex items-center">
            <slot name="before"></slot>
            <input :checked="isChecked" :disabled="disabled" class="hidden" type="checkbox" @change="toggle">

            <span :class="[before ? 'ml-8' : 'mr-8']"
                class="w-32 p-4 toggle rounded-32 flex trans-ease flex-none"
            >
                <span :class="[isChecked ? 'translate-x-12' : 'translate-x-0']"
                      class="w-12 h-12 trans-ease transform bg-white rounded-32"></span>
            </span>
            <span v-if="$slots.default"
                  :class="[capitalized ? 'first-letter:uppercase' : '', before ? 'order-first' : '']"
                  class="toggle-label trans-ease leading-snug select-none -mt-2">
                <slot></slot>
            </span>
        </label>
    </div>
</template>

<script>
export default {
    model: {
        prop: 'checked',
        event: 'change',
    },
    props: {
        value: [String, Number],
        checked: [Array, Boolean],
        disabled: Boolean,
        classes: String,
        capitalized: Boolean,
        before: {type: Boolean, default: false},
    },
    computed: {
        isChecked() {
            return Array.isArray(this.checked) ? this.checked.includes(this.value) : this.checked;
        },
    },
    methods: {
        toggle: function (event) {
            let checked = this.checked;

            if (Array.isArray(this.checked)) {
                if (event.target.checked) {
                    checked = [...checked, ...[this.value]];
                } else {
                    checked.splice(checked.indexOf(this.value), 1);
                }
            } else {
                checked = event.target.checked;
            }

            this.$emit('change', checked);
        },
    },
};
</script>

<style scoped>
input[type='checkbox'] {
    &:checked:not(:disabled) {
        & ~ .toggle-label {
            @apply text-secondary;
        }
        & ~ .toggle {
            @apply bg-secondary;
        }
    }
    &:disabled {
        & ~ .toggle-label {
            @apply text-black;
        }
        & ~ .toggle {
            @apply bg-primary-40;
        }
    }
    &:checked:disabled {
        & ~ .toggle-label {
            @apply text-black;
        }
        & ~ .toggle {
            @apply bg-primary-40;
        }
    }
    &:not(:checked):not(:disabled) {
        & ~ .toggle-label {
            @apply text-black;
        }

        &:hover ~.toggle-label {
            @apply text-primary;
        }

        & ~ .toggle {
            @apply bg-primary-60;
        }

        &:hover ~ .toggle {
            @apply bg-primary;
        }
    }
}
</style>
